<div class="page">
  <button (click)="createNewServiceGroup()">Create new ServiceGroup</button>
  <button (click)="edit()">{{ uiState === 'edit' ? 'Cancel' : 'Edit' }}</button>

  <!-- ListServiceGroup -->
  @if (uiState === 'list' || uiState === 'edit') {
    <div class="list">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col" sortable="Name">Name</th>
            <th scope="col" sortable="UserCount">User Count</th>
            <th scope="col" sortable="CompanyCount">Company Count</th>
            @if (uiState === 'edit') {
              <th scope="col">Modify</th>
            }
            @if (uiState === 'edit') {
              <th scope="col">X</th>
            }
          </tr>
        </thead>
        @if (servicegroups$ | async; as servicegroups) {
          <tbody>
            <!-- | async -->
            @for (servicegroup of servicegroups; track servicegroup) {
              <tr>
                <th scope="row">{{ servicegroup.id }}</th>
                <td>{{ servicegroup.name }}</td>
                <td>{{ servicegroup.userIds.length }}</td>
                <td>{{ servicegroup.companyIds.length }}</td>
                <td>
                  @if (uiState === 'edit') {
                    <button class="deleteButton" (click)="modifyServiceGroup(servicegroup)">Modify</button>
                  }
                </td>
                <td>
                  @if (uiState === 'edit') {
                    <button class="deleteButton" (click)="deleteServiceGroup(servicegroup)">X</button>
                  }
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    </div>
  }

  <!-- CreateUser -->
  @if (uiState === 'create' || uiState === 'modify') {
    <div class="formDiv">
      <form class="newForm" [formGroup]="form" (ngSubmit)="onSubmit()">
        @if (form.Id) {
          <div class="activeRow ml-1">
            ID:
            <label class="formElement">{{ form.Id }}</label>
          </div>
        }
        <input class="formElement" placeholder="Name" type="text" formControlName="Name" />
        @if (coreusers$ | async; as coreusers) {
          <ng-select
            class="select"
            [items]="coreusers"
            bindLabel="email"
            bindValue="id"
            [multiple]="true"
            placeholder="Select Users"
            formControlName="Users"
            >
          </ng-select>
        }
        <ng-select
          class="select"
          [items]="companies$ | async"
          bindLabel="name"
          bindValue="id"
          [multiple]="true"
          placeholder="Select Companies"
          formControlName="Companies"
          >
        </ng-select>
        <button type="submit" [disabled]="!form.valid">Submit</button>
        <button type="reset" (click)="cancelNewUser()">Cancel</button>
      </form>
    </div>
  }
</div>
